import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})

export class AuthService{
    constructor(private http:HttpClient){}

    login(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/userLogin";
        return this.http.post<any>(url, body, { headers });
    }
    loginWithToken(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/userLoginWithToken";
        return this.http.post<any>(url, body, { headers });
    }

    setPassword(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/setPassword";
        return this.http.post<any>(url, body, { headers });
    }
    resetPassword(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/resetPassword";
        return this.http.post<any>(url, body, { headers });
    }
    changePassword(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/changePassword";
        return this.http.post<any>(url, body, { headers });
    }
    
    logout(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/userLogout";
        return this.http.post<any>(url, body, { headers });
    }
    check_login(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/checkUserLogin";
        return this.http.post<any>(url, body, { headers });
    }

    signup(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/registerUser";
        return this.http.post<any>(url, body, { headers });
    }

    verifySignupToken(token: string){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/verify-signup-token";
        return this.http.post<any>(url, {
            token: token
        }, { headers });
    }

    register(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/registration";
        return this.http.post<any>(url, body, { headers });
    }

    setupDownloadLink(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/send-download-link";
        return this.http.post<any>(url, body, { headers });
    }

    verifyDownload(token: string){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/verify-download";
        return this.http.post<any>(url, {
            token: token
        }, { headers });
    }

    sendRegistrationLink(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/send-registration-link";
        return this.http.post<any>(url, body, { headers });
    }
    forgotPassword(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/forgotPassword";
        return this.http.post<any>(url, body, { headers });
    }
    loginWithLoginToken(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/loginWithLoginToken";
        return this.http.post<any>(url, body, { headers });
    }
}
